import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  id: "app",
  style: {"min-width":"1007px"}
}

import { ElConfigProvider } from 'element-plus';
import zhCn from 'element-plus/es/locale/lang/zh-cn';
import en from 'element-plus/es/locale/lang/en';
import { onMounted } from 'vue';
import { useUserStore } from './store/user';


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const userBase = useUserStore();

onMounted(() => {
	setRem();
	window.addEventListener('resize', () => setRem());

	userBase.init();
	userBase.getUserInfo();
	userBase.setIsChina();

	listenerScreenChang();
});

function setRem() {
	const size = (window.innerWidth / 1920) * 16;
	const element: any = document.documentElement;
	element.style = `font-size:${size < 14 ? 14 : size}px`;
}

function listenerScreenChang() {
	document.addEventListener('fullscreenchange', handleFullscreenChange);
	document.addEventListener('webkitfullscreenchange', handleFullscreenChange); // Safari/Chrome 旧版
	document.addEventListener('mozfullscreenchange', handleFullscreenChange); // Firefox 旧版
	document.addEventListener('MSFullscreenChange', handleFullscreenChange); // IE/Edge

	function handleFullscreenChange() {
		// 检查当前是否有元素处于全屏状态
		if (
			document.fullscreenElement ||
			document.webkitFullscreenElement ||
			document.mozFullScreenElement ||
			document.msFullscreenElement
		) {
			userBase.isOpenScreenFull = true;
		} else {
			userBase.isOpenScreenFull = false;
		}
	}
}

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_unref(ElConfigProvider), {
    locale: _unref(userBase).language=='zh'?_unref(zhCn):_unref(en)
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_router_view)
      ])
    ]),
    _: 1
  }, 8, ["locale"]))
}
}

})